import React, { useRef } from "react";
import { Upload } from "react-bootstrap-icons";

const ImageUploadButton = ({ onUpload }) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (onUpload) {
        onUpload(file);
      }
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn filter-btn d-flex align-items-center gap-2 px-3"
        onClick={handleClick}
      >
        <Upload size={17} />
        <span>Upload Image</span>
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="d-none"
        onChange={handleFileChange}
      />
    </>
  );
};

export default ImageUploadButton;
